import React, { createContext, useContext, useState, useCallback } from 'react';
import { AddToPlaylistModal } from '../components/AddToPlaylistModal';
import { useAuth } from '../App';

const AddToPlaylistContext = createContext(null);

export function useAddToPlaylist() {
  return useContext(AddToPlaylistContext);
}

export function AddToPlaylistProvider({ children }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [trackId, setTrackId] = useState(null);

  const isPremium = user?.subscription_tier?.startsWith('premium');

  const openForTrack = useCallback((id) => {
    if (!isPremium || !id) return;
    setTrackId(id);
    setOpen(true);
  }, [isPremium]);

  return (
    <AddToPlaylistContext.Provider value={{ openForTrack, isPremium }}>
      {children}
      <AddToPlaylistModal open={open} onOpenChange={setOpen} trackId={trackId} />
    </AddToPlaylistContext.Provider>
  );
}
